import React, { Component } from "react";
import {
  Table as BootstrapTable,
  Row,
  Col
} from "react-bootstrap";
import moment from "moment";

import { IS_VALID } from "utils";

export default class View extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isLoadingRelation: false,
      transactionType: [],
      sendPushNotification: [],
      cardType: [],
      specificUser: [],
      blacklistedUser: [],
      evScannerUser: []
    };

    this.getRelation = this.getRelation.bind(this);
  }

  getRelation () {
    let {
      actions,
      EVoucher,
      getRelation
    } = this.props;

    let {
      formType,
      selectedData
    } = EVoucher;

    if (IS_VALID(selectedData)) {

      this.setState({ isLoadingRelation: true });

      getRelation()
      .then(([ transactionType, sendPushNotification, cardType, specificUser, blacklistedUser, evScannerUser ]) => {
        let transactionTypeArray = transactionType.map((item) => item.get("name"));

        let sendPushNotificationArray = sendPushNotification.map((item) => item.get("name"));

        let cardTypeArray = cardType.map((item) => item.get("name"));

        let specificUserArray = specificUser.map((item) => `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`);

        let blacklistedUserArray = blacklistedUser.map((item) => `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`);

        let evScannerUserArray = evScannerUser.map((item) => item.get("name"));

        this.setState({
          isLoadingRelation: false,
          transactionType: transactionTypeArray,
          sendPushNotification: sendPushNotificationArray,
          cardType: cardTypeArray,
          specificUser: specificUserArray,
          blacklistedUser: blacklistedUserArray,
          evScannerUser: evScannerUserArray
        });
      })
      .catch((err) => {
        console.log("err", err);
        this.setState({ isLoadingRelation: false });
      });
    }
  }

  render() {
    let {
      isLoadingRelation,
      transactionType,
      sendPushNotification,
      cardType,
      specificUser,
      blacklistedUser,
      evScannerUser
    } = this.state;

    let {
      EVoucher
    } = this.props;

    let {
      selectedData,
      birthMonthOptions
    } = EVoucher;

    const GET_VALUE = (key, isShortName = false) => {
      if (IS_VALID(selectedData) && IS_VALID(selectedData.get(key))) {
        let value = "";

        if (
          key === "typeK" ||
          key === "deductPointType" ||
          key === "pointType" ||
          key === "promoCategory" ||
          key === "campaignCategory"
        ) {
          let keyName = "name";

          if (key === "campaignCategory") {
            keyName = "title";
          } 

          value = selectedData.get(key).get(isShortName ? "shortName" : keyName);
        } else if (
          key === "earningPeriodStartDate" ||
          key === "earningPeriodEndDate" ||
          key === "createdAt" ||
          key === "updatedAt"
        ) {
          value = moment(selectedData.get(key)).format("MMM-DD-YYYY");
        } else if (
          key === "tdd_campaignStartDate" ||
          key === "tdd_campaignEndDate" ||
          key === "tdd_earningPeriodStartDate" ||
          key === "tdd_earningPeriodEndDate"
        ) {
          value = moment(selectedData.get(key)).format("MMM-DD-YYYY hh:mm:ss A") + " TDD";
        } else if (
          key === "campaignStartDate" ||
          key === "campaignEndDate" ||
          key === "voucherValidityStartDate" ||
          key === "voucherValidityEndDate" ||
          key === "tdd_birthMonthStartDate" ||
          key === "tdd_birthMonthEndDate"
        ) {
          value = moment(selectedData.get(key)).format("MMM-DD-YYYY hh:mm:ss A");
        } else if (
          key === "isShowRemainingQuantity" ||
          key === "isRateRequired" ||
          key === "isShowForFirstTimeUsers" ||
          key === "isShowMerchantsOwnRedemptionOnly",
          key === 'voucherValidityIsUseCalendarDay'
        ) {
          value = (selectedData.get(key) || false).toString().toUpperCase();
        } else if (key === "gender") {
          value = [ "ALL", "MALE", "FEMALE" ].indexOf(selectedData.get(key)) !== -1 ? selectedData.get(key) : "Unknown";
        } else if (
          key === "voucherValidityEndTime"
        ) {
          value = moment(selectedData.get(key)).format("hh:mm A");
        } else if (
          key === "createdBy" ||
          key === "updatedBy"
        ) {
          if (IS_VALID(selectedData.get(key))) {
            value = selectedData.get(key).get("name") || "";
          }
        } else {
          value = selectedData.get(key);
        }

        return value;
      } else {
        return "";
      }
    };

    let data = [
      {
        label: "Type K",
        value: GET_VALUE("typeK")
      },
      {
        label: "Transaction Type",
        value: isLoadingRelation ? (
          <i className="fa fa-spinner fa-spin"></i>
        ) : (
          transactionType.join(", ")
        )
      },
      {
        label: "Point Type",
        value: GET_VALUE("pointType")
      },
      {
        label: "Deduct Point Type",
        value: GET_VALUE("deductPointType")
      },
      {
        label: "Card Type",
        value: isLoadingRelation ? (
          <i className="fa fa-spinner fa-spin"></i>
        ) : (
          cardType.join(", ")
        )
      },
      {
        label: "Send Push Notification",
        value: isLoadingRelation ? (
          <i className="fa fa-spinner fa-spin"></i>
        ) : (
          sendPushNotification.join(", ")
        )
      },
      {
        label: "Gender",
        value: GET_VALUE("gender")
      },
      {
        label: "Requried Earning Amount",
        value: GET_VALUE("requiredEarningAmount")
      },
      {
        label: "Deduct Amout",
        value: GET_VALUE("deductPointAmount")
      },
      {
        label: "Max Voucher Quantity",
        value: GET_VALUE("maxVoucherQuantity")
      },
      {
        label: "Max Voucher Quantity Per Day",
        value: GET_VALUE("maxVoucherQuantityPerDay")
      },
      {
        label: "Max Voucher Quantity Per User",
        value: GET_VALUE("maxVoucherQuantityPerUser")
      },
      {
        label: "Max Voucher Quantity Per User Per Day",
        value: GET_VALUE("maxVoucherQuantityPerUserPerDay")
      }
    ];


    let data2 = [
      {
        label: "Earning Period",
        value: ""
      },
      {
        label: "Campaign Start Date",
        value: [
          GET_VALUE("campaignStartDate"),
          <br/>,
          GET_VALUE("tdd_campaignStartDate")
        ]
      },
      {
        label: "Campaign End Date",
        value: [
          GET_VALUE("campaignEndDate"),
          <br/>,
          GET_VALUE("tdd_campaignEndDate")
        ]
      },
      {
        label: "Voucher Validity Type",
        value: ""
      }
    ];

    let earningPeriod = GET_VALUE("earningPeriod");

    if (earningPeriod !== "") {
      data2[0].value = earningPeriod.get("name");

      if (earningPeriod.get("shortName") === "DR") {
        data2.splice(
          1,
          0,
          {
            label: "Earning Period Start Date",
            value: [
              GET_VALUE("earningPeriodStartDate"),
              <br/>,
              GET_VALUE("tdd_earningPeriodStartDate")
            ]
          },
          {
            label: "Earning Period End Date",
            value: [
              GET_VALUE("earningPeriodEndDate"),
              <br/>,
              GET_VALUE("tdd_earningPeriodEndDate")
            ]
          }
        );
      }
    }

    let typeK = GET_VALUE("typeK", true),
        birthMonth = GET_VALUE("birthMonth"),
        welcomeDays = GET_VALUE("welcomeDays");

    if (
      IS_VALID(typeK) &&
      typeK === "B" &&
      IS_VALID(birthMonth)
    ) {
      let index = data2.map(({ label }) => label).indexOf("Campaign Start Date"),
          birthMonthIndex = birthMonthOptions.map(({ value }) => value).indexOf(birthMonth);

      if (birthMonthIndex !== -1) {
        data2.splice(
          index,
          0,
          {
            label: "Birth Month",
            value: [
              <Row>
                <Col md={12}>
                  {birthMonthOptions[birthMonthIndex].label}
                </Col>
              </Row>,
              <Row>
                <Col md={6}>
                  <p>
                    Start
                    <br/>
                    {GET_VALUE("tdd_birthMonthStartDate")}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    End
                    <br/>
                    {GET_VALUE("tdd_birthMonthEndDate")}
                  </p>
                </Col>
              </Row>
            ]
          }
        );
      }
    }

    if (
      IS_VALID(typeK) &&
      typeK === "W" &&
      IS_VALID(welcomeDays)
    ) {
      let index = data2.map(({ label }) => label).indexOf("Campaign End Date");

      data2.splice(
        index + 1,
        0,
        {
          label: "Welcome Days",
          value: welcomeDays
        }
      );
    }

    let voucherValidityType = GET_VALUE("voucherValidityType");

    let getTotalVoucherValidity = (hour, minute, second) => {
      let totalDays = 0,
          totalHours = 0,
          totalMinutes = 0,
          totalSeconds = 0;

      if (IS_VALID(hour) && parseFloat(hour) % 1 !== 0) {
        return "Hour should be a whole number.";
      } else if (IS_VALID(hour) && parseInt(hour) > 0) {
        totalDays = Math.floor(hour/24);

        totalHours = parseInt(hour)-(totalDays*24);
      }

      if (IS_VALID(minute) && parseFloat(minute) % 1 !== 0) {
        return "Minute should be a whole number.";
      } else if (IS_VALID(minute) && parseInt(minute) > 0) {
        let additionalHours = Math.floor(minute/60);

        if (additionalHours > 0) {
          totalHours += additionalHours;
        }

        totalMinutes = parseInt(minute)-(additionalHours*60);
      }

      if (IS_VALID(second) && parseFloat(second) % 1 !== 0) {
        return "Second should be a whole number.";
      } else if (IS_VALID(second) && parseInt(second) > 0) {
        let additionalMinutes = Math.floor(second/60);

        if (additionalMinutes > 0) {
          totalMinutes += additionalMinutes;
        }

        totalSeconds = parseInt(second)-(additionalMinutes*60);
      }

      return `${totalDays} day ${totalHours} hour ${totalMinutes} minute ${totalSeconds} second`;
    };

    if (voucherValidityType !== "") {
      let index = data2.map((item) => item.label).indexOf("Voucher Validity Type");

      data2[index].value = voucherValidityType.get("name");

      if (voucherValidityType.get("shortName") === "T") {
        let voucherValidityTimeConfig = GET_VALUE("voucherValidityTimeConfig"),
            hour = 0,
            minute = 0,
            second = 0;

        if (voucherValidityTimeConfig !== "") {
          hour = voucherValidityTimeConfig.hour || 0;
          minute = voucherValidityTimeConfig.minute || 0;
          second = voucherValidityTimeConfig.second || 0;
        }

        data2.splice(
          index+1,
          0,
          {
            label: "Total Voucher Validity",
            value: getTotalVoucherValidity(hour, minute, second)
          }
        );
      } else if (voucherValidityType.get("shortName") === "DR") {

        data2.splice(
          index+1,
          0,
          {
            label: "Use Calendar Day",
            value: GET_VALUE("voucherValidityIsUseCalendarDay")
          },
          {
            label: "Voucher Validity Date",
            value: (
              <Row>
                <Col md={6}>
                  <p>
                    Start
                    <br/>
                    {GET_VALUE("voucherValidityStartDate")}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    End
                    <br/>
                    {GET_VALUE("voucherValidityEndDate")}
                  </p>
                </Col>
              </Row>
            )
          }
        );
      } else if (voucherValidityType.get("shortName") === "SDT") {
        let voucherValidityTimeConfig = GET_VALUE("voucherValidityTimeConfig");

        data2.splice(
          index+1,
          0,
          {
            label: "Use Calendar Day",
            value: GET_VALUE("voucherValidityIsUseCalendarDay")
          },
          {
            label: "Voucher Validity Start and End Time",
            value: (
              <Row>
                <Col md={6}>
                  <p>
                    Start
                    <br/>
                    {voucherValidityTimeConfig && voucherValidityTimeConfig.start}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    End
                    <br/>
                    {voucherValidityTimeConfig && voucherValidityTimeConfig.end}
                  </p>
                </Col>
              </Row>
            )
          }
        );
      } else if (voucherValidityType.get("shortName") === "DT") {
        let voucherValidityTimeConfig = GET_VALUE("voucherValidityTimeConfig");

        data2.splice(
          index+1,
          0,
          {
           label: "Voucher Validity Days",
           value: GET_VALUE("voucherValidityDays")
          },
          {
            label: "Voucher Validity End Time",
            value: voucherValidityTimeConfig && voucherValidityTimeConfig.end
          }
        );
      }
    }

    let data3 = [
      {
        label: "Specific User",
        value: isLoadingRelation ? (
          <i className="fa fa-spinner fa-spin"></i>
        ) : (
          <div
            style={{
              maxHeight: "200px",
              overflowY: "scroll"
            }}
          >
            {specificUser.join(", ")}
          </div>
        )
      },
      {
        label: "Excluded User",
        value: isLoadingRelation ? (
          <i className="fa fa-spinner fa-spin"></i>
        ) : (
          <div
            style={{
              maxHeight: "200px",
              overflowY: "scroll"
            }}
          >
            {blacklistedUser.join(", ")}
          </div>
        )
      }
    ];

    let data4 = [
      {
        label: "Image",
        value: GET_VALUE("image") !== "" ? (
          <div
            style={{
              maxWidth: "200px",
              maxHeight: "200px",
              height: "200px",
              width: "200px",
              display: "table-cell",
              verticalAlign: "middle"
            }}>
            <img
              src={GET_VALUE("image").url()}
              width="100%"
            />
          </div>
        ) : (
          ""
        )
      },
      {
        label: "Voucher Version",
        value: GET_VALUE("version")
      },
      {
        label: "Campaign Category",
        value: GET_VALUE("campaignCategory")
      },
      {
        label: "Title",
        value: GET_VALUE("title")
      },
      {
        label: "Promotion Name",
        value: GET_VALUE("promotionName")
      },
      {
        label: "Description",
        value: (
          <p style={{ whiteSpace: "pre-wrap" }}>
            {GET_VALUE("descriptions")}
          </p>
        )
      },
      {
        label: "Where to Redeem",
        value: (
          <p style={{ whiteSpace: "pre-wrap" }}>
            {GET_VALUE("whereToRedeem")}
          </p>
        )
      },
      {
        label: "EV Scanner User",
        value: isLoadingRelation ? (
          <i className="fa fa-spinner fa-spin"></i>
        ) : (
          <div
            style={{
              maxHeight: "200px",
              overflowY: "scroll"
            }}
          >
            {evScannerUser.join(", ")}
          </div>
        )
      },
      {
        label: "Serial Number Prefix",
        value: GET_VALUE("serialNumberPrefix")
      },
      {
        label: "Budget Amount",
        value: GET_VALUE("amount")
      },
      {
        label: "Promo Owner Cost Center",
        value: GET_VALUE("promoOwnerCostCenter")
      },
      {
        label: "Promo Category",
        value: GET_VALUE("promoCategory")
      },
      {
        label: "NNSL Amount",
        value: GET_VALUE("nnsl_amount")
      },
      {
        label: "NNC Amount",
        value: GET_VALUE("nnc_amount")
      },
      {
        label: "Show for First time Users (for Welcome Voucher Only)",
        value: ""
      },
      {
        label: "Show Remaining Quantity",
        value: GET_VALUE("isShowRemainingQuantity")
      },
      {
        label: "Show Rate form after redeem",
        value: GET_VALUE("isRateRequired")
      },
      {
        label: "Show Merchant's own redemption only",
        value: GET_VALUE("isShowMerchantsOwnRedemptionOnly")
      },
      {
        label: "Created At",
        value: GET_VALUE("createdAt")
      },
      {
        label: "Update At",
        value: GET_VALUE("updatedAt")
      },
      {
        label: "Created By",
        value: GET_VALUE("createdBy")
      },
      {
        label: "Update By",
        value: GET_VALUE("updatedBy")
      }
    ];

    if (GET_VALUE("isRateRequired") === "TRUE") {
      let rateTimeConfig = GET_VALUE("rateTimeConfig"),
          hour = 0,
          minute = 0,
          second = 0;

      if (rateTimeConfig !== "") {
        hour = rateTimeConfig.hour || 0;
        minute = rateTimeConfig.minute || 0;
        second = rateTimeConfig.second || 0;
      }

      data4.splice(
        11,
        0,
        {
          label: "Total Time before Rate form show",
          value: getTotalVoucherValidity(hour, minute, second)
        }
      );
    }

    if (
      IS_VALID(typeK) &&
      typeK === "W"
    ) {
      let index = data4.map(({ label }) => label).indexOf("Show for First time Users (for Welcome Voucher Only)");

      data4.splice(
        index,
        1,
        {
          label: "Show for First time Users (for Welcome Voucher Only)",
          value: GET_VALUE("isShowForFirstTimeUsers")
        }
      );
    }

    return (
      <div>
        <BootstrapTable
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </BootstrapTable>

        <BootstrapTable
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data2.map((item, index) => (
              <tr key={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </BootstrapTable>

        <BootstrapTable
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data3.map((item, index) => (
              <tr key={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </BootstrapTable>

        <BootstrapTable
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data4.map((item, index) => (
              <tr key={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </BootstrapTable>
      </div>
    );
  }

  componentDidMount () {
    this.getRelation();
  }
}



// WEBPACK FOOTER //
// ./components/EVoucher/FormContainer/View.js